export const userIdSessionStorageKey = 'UserId'
export const userNameSessionStorageKey = 'UserName'
